import {
    PATH_DEVICE_ACTIVITY,
    PATH_DEVICE_OPERATIONAL_STATISTIC,
    PATH_DEVICE_OPERATIONAL_STATISTIC_BY_DEVICES
} from "@constants/navigate";
import {IStatisticNavigateItem} from '../types'
import {IS_SEPARATED} from "@constants/config";


const BASE_statisticNavigate: IStatisticNavigateItem[] = [
    {
        label: 'deviceOperationStatistic.name',
        path: PATH_DEVICE_OPERATIONAL_STATISTIC,
    },
    {
        label: 'deviceOperationStatistic.byDevices',
        path: PATH_DEVICE_OPERATIONAL_STATISTIC_BY_DEVICES,
    },
]


export const statisticNavigate: IStatisticNavigateItem[] = IS_SEPARATED ? BASE_statisticNavigate : [
    ...BASE_statisticNavigate,
    {
        label: 'base.deviceActivity',
        path: PATH_DEVICE_ACTIVITY,
    },

]
